import { useCallback } from 'react';
import mathquill4quill from 'mathquill4quill';
import katex from 'katex';
import { Quill } from 'react-quill';

// Default operator palette (can be overridden by passing a custom list)
const defaultOperators = [
  ["\\pm", "\\pm"],
  ["\\sqrt{x}", "\\sqrt"],
  ["\\sqrt[3]{x}", "\\sqrt[3]{}"],
  ["\\sqrt[n]{x}", "\\nthroot"],
  ["\\frac{x}{y}", "\\frac"],
  ["\\sum^{s}_{x}{d}", "\\sum"],
  ["\\prod^{s}_{x}{d}", "\\prod"],
  ["\\coprod^{s}_{x}{d}", "\\coprod"],
  ["\\int^{s}_{x}{d}", "\\int"],
  ["\\binom{n}{k}", "\\binom"],
  ['E = mc^2', 'E = mc^2'],
  ['\\Delta x = \\frac{v_f - v_i}{t}', '\\Delta x = \\frac{v_f - v_i}{t}'],
  ['x = \\frac{-b \\pm \\sqrt{b^2 - 4ac}}{2a}', 'x = \\frac{-b \\pm \\sqrt{b^2 - 4ac}}{2a}'],
  ['\\vec{F} = m\\vec{a}', '\\vec{F} = m\\vec{a}'],
  ['\\sin^2{x} + \\cos^2{x} = 1', '\\sin^2{x} + \\cos^2{x} = 1'],
  ['\\frac{d}{dx}e^x = e^x', '\\frac{d}{dx}e^x = e^x'],
  ['\\int_{a}^{b} f(x) dx', '\\int_{a}^{b} f(x) dx'],
  ['\\ln{x}', '\\ln'],
  ["\\alpha", "\\alpha"],
  ["\\beta", "\\beta"],
  ["\\gamma", "\\gamma"],
  ["\\delta", "\\delta"],
  ["\\epsilon", "\\epsilon"],
  ['\\sin{x}', '\\sin'],
  ['\\cos{x}', '\\cos'],
  ['\\tan{x}', '\\tan'],
  ['\\cot{x}', '\\cot'],
  ['\\sec{x}', '\\sec'],
  ['\\csc{x}', '\\csc'],
  ['\\arcsin{x}', '\\arcsin'],
  ['\\arccos{x}', '\\arccos'],
  ['\\arctan{x}', '\\arctan'],
  ['\\sinh{x}', '\\sinh'],
  ['\\cosh{x}', '\\cosh'],
  ['\\tanh{x}', '\\tanh'],
  ['\\coth{x}', '\\coth'],
  ['\\sech{x}', '\\sech'],
  ['\\csch{x}', '\\csch'],
  ['\\arcsinh{x}', '\\arcsinh'],
  ['\\arccosh{x}', '\\arccosh'],
  ['\\arctanh{x}', '\\arctanh'],
  ['\\arccoth{x}', '\\arccoth'],
  ['\\arcsech{x}', '\\arcsech'],
  ['\\arccsch{x}', '\\arccsch']
];

export function useMathQuillInit(operators = defaultOperators) {
  return useCallback((quillComponent) => {
    if (!quillComponent || typeof quillComponent.getEditor !== 'function') return;
    const editor = quillComponent.getEditor();
    const enable = mathquill4quill({ Quill, katex });
    try {
      enable(editor, {
        displayHistory: true,
        operators,
        displayDeleteButtonOnHistory: true,
      });
    } catch (e) {
      // Fail silently; editor still works without math palette
      // console.warn('mathquill4quill init failed', e);
    }
  }, [operators]);
}
